import { Link } from "@remix-run/react";

import { isValidUrl } from "~/utils/isValidUrl";

import { useGlobalContext } from "../context/GlobalContext";

import type { GetNavigationQuery } from "~/generated/schema.graphcms";

export default function Navbar({ config }: { config: GetNavigationQuery["header"] }): React.ReactNode {
	const navLinks = config?.links;
	const { mobileNav, setMobileNav } = useGlobalContext();

	function hamburgerClick(): void {
		setMobileNav(!mobileNav);
	}

	return (
		<nav className={mobileNav ? "navbar mobile-open" : "navbar mobile-closed"}>
			<div className="navbar-brand">
				<a className="navbar-item py-0" href="/">
					<img src="/images/RLS_Logo_Final_RGB.png" alt="Rocket League Sideswipe" />
				</a>
				<div
					className="navbar-burger"
					data-target="navbar"
					onClick={hamburgerClick}
					onKeyDown={hamburgerClick}
					role="presentation"
				>
					<span></span>
					<span></span>
					<span></span>
				</div>
			</div>

			<div id="navbar" className="navbar-menu">
				<div className="navbar-start">
					{navLinks?.map((navLink) =>
						navLink.href && isValidUrl(navLink.href) ? (
							<Link key={navLink.href} to={navLink.href} className={`navbar-item has-text-light is-uppercase`}>
								{navLink.title}
							</Link>
						) : (
							<Link key={navLink.href} to={navLink.href ?? "/"} className={`navbar-item has-text-light is-uppercase`}>
								{navLink.title}
							</Link>
						),
					)}
				</div>

				<div className="navbar-end">
					{/* Locale switcher: ?setlang=<locale> triggers a server-side 302 +
					    Set-Cookie EPIC_LOCALE in handleUrlRedirect. reloadDocument
					    forces a full request so the cookie is picked up on the next render. */}
					<div className="navbar-item has-dropdown is-hoverable">
						<a className="navbar-link has-text-light" href="#">
							<img src="/images/icons/icon-locale.svg" width="20px" height="20px" alt="Select Locale" />
						</a>
						<div className="navbar-dropdown is-boxed">
							<Link className="navbar-item has-text-light" to="?setlang=en" reloadDocument>
								English
							</Link>
							<Link className="navbar-item has-text-light" to="?setlang=de" reloadDocument>
								Deutsch
							</Link>
							<Link className="navbar-item has-text-light" to="?setlang=fr" reloadDocument>
								Français
							</Link>
							<Link className="navbar-item has-text-light" to="?setlang=pt-br" reloadDocument>
								Português (Brasil)
							</Link>
							<Link className="navbar-item has-text-light" to="?setlang=es-es" reloadDocument>
								Español (Spain)
							</Link>
							<Link className="navbar-item has-text-light" to="?setlang=es-mx" reloadDocument>
								Español (LA)
							</Link>
							<Link className="navbar-item has-text-light" to="?setlang=it" reloadDocument>
								Italiano
							</Link>
						</div>
					</div>
					<div className="navbar-item">
						<div className="field is-grouped">
							<p className="control">
								<a className="button is-info is-uppercase" href="/download">
									<span>
										<strong>{config?.callToAction?.title}</strong>
									</span>
								</a>
							</p>
						</div>
					</div>
				</div>
			</div>
		</nav>
	);
}
